import React from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import AboutUsContent from "./AboutUsContent";
import VisionMissionGoal from "./VisionMissionGoal";
import WhyStandOutSection from "./WhyStandOutSection";
import WhyChooseSemars from "./WhyChooseSemars";
import Testimonials from "./TestimonialsSection";
import ABoutusPgBackground from "../../Images/aboutus-bg.webp";

const AboutUsPage = () => {
  return (
    <div>
      <Header />
      <section
        className={`relative w-full h-auto bg-cover bg-no-repeat `}
        style={{
          backgroundImage: `url(${ABoutusPgBackground})`,
        }}
      >
        <AboutUsContent />
        <VisionMissionGoal />
        <WhyStandOutSection />
        <WhyChooseSemars />
      </section>
      <Testimonials />
      <Footer />
    </div>
  );
};

export default AboutUsPage;
